import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography, Button } from '@material-ui/core';
import classNames from 'classnames';
import isString from 'lodash/isString';
import { keyEmptyCheck } from 'aurora-utils/utils';
import cancelIcon from 'aurora-images/cross_black.svg';
import { ADGMModal } from 'aurora-components';

import styles from './styles';

const ADGMAcknowledgementPopup = props => {
  const {
    children,
    classes,
    open,
    title,
    description,
    cancelBtnText,
    proceedBtnText,
    onCloseHandler,
    onCancelHandler,
    onProceedHandler,
    disableProceedBtn,
    disableCancelBtn,
    customClasses,
    ...otherProps
  } = props;
  return (
    <ADGMModal
      className={classNames(classes.modal, customClasses?.modal)}
      open={open}
      disableScrollLock={false}
      {...otherProps}
    >
      <div className={classes.header}>
        <Typography className={classes.headerTitle}>{isString(title) ? keyEmptyCheck(title) : title}</Typography>
        <Button className={classes.headerCloseBtn} onClick={onCloseHandler}>
          <img className={classes.headerCloseBtnIcon} src={cancelIcon} alt='cancel' />
        </Button>
      </div>
      {description && (
        <Typography className={classNames(classes.description, customClasses?.description)}>
          {isString(description) ? keyEmptyCheck(description) : description}
        </Typography>
      )}
      {children}
      <div className={classNames(classes.actions, customClasses?.actions)}>
        <Button
          className={classNames(classes.actionBtn, classes.cancelBtn, customClasses.actionBtn, {
            [classes.disableBtn]: disableCancelBtn,
          })}
          onClick={onCancelHandler}
          disabled={disableCancelBtn}
        >
          {keyEmptyCheck(cancelBtnText)}
        </Button>
        <Button
          className={classNames(classes.actionBtn, classes.proceedBtn, customClasses?.actionBtn, customClasses?.actionBtnOnly, {
            [classes.disableBtn]: disableProceedBtn,
          })}
          onClick={onProceedHandler}
          disabled={disableProceedBtn}
        >
          {keyEmptyCheck(proceedBtnText)}
        </Button>
      </div>
    </ADGMModal>
  );
};

ADGMAcknowledgementPopup.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  title: PropTypes.any.isRequired,
  description: PropTypes.any,
  cancelBtnText: PropTypes.string,
  proceedBtnText: PropTypes.string,
  disableProceedBtn: PropTypes.bool,
  disableCancelBtn: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onCancelHandler: PropTypes.func.isRequired,
  onProceedHandler: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
  otherProps: PropTypes.object,
};

ADGMAcknowledgementPopup.defaultProps = {
  children: null,
  description: '',
  cancelBtnText: 'cancel',
  proceedBtnText: 'continue',
  disableProceedBtn: false,
  disableCancelBtn: false,
  customClasses: {},
  otherProps: {},
};
export default withStyles(styles)(ADGMAcknowledgementPopup);
